(() => {
  const name = 'footer';

  App.common = App.common || {};

  App.common[name] = (() => {
    const setEventListeners = () => {
      function toggleClass() {
        this.classList.toggle('expanded');
      }

      const footerToggle = document.querySelectorAll('.js-footer-group__toggle');
      const isFooterToggleVisible = window.screen.width < 1024;

      for (let j = 0; j < footerToggle.length; j += 1) {
        footerToggle[j].onclick = toggleClass;

        if (isFooterToggleVisible) {
          footerToggle[j].setAttribute('role', 'button');
          footerToggle[j].setAttribute('tabindex', '0');
        }
      }
    };

    const init = () => {
      setEventListeners();
    };

    return {
      init,
    };
  })();
})();
